import * as Config from '../../../../config';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FixedSizeGrid, areEqual } from "react-window";

import BlockLoading from '../../common/BlockLoading';

import { GridContext } from '../../../../contexts/grid-context';

let BLOCKLOAD = false;

const Cell = React.memo(function Cell({ data, columnIndex, rowIndex, style }) {
  const { columns, loadMore, gutter, element, loadingElement } = useContext(GridContext);
  const item = data[(rowIndex * columns) + columnIndex];

  const isExists = data[(rowIndex * columns) + columnIndex];
  if (!isExists && !BLOCKLOAD && loadMore) {
    BLOCKLOAD = true;
    loadMore(() => { BLOCKLOAD = false });
  }

  const mergeStyle = (style) => ({
    ...style,
    width: style.width - gutter.width,
    top: style.top + gutter.top,
    left: style.left + gutter.left + ((gutter && gutter.gap) ? (columnIndex * gutter.gap) : 0)
  });

  return (isExists && React.isValidElement(element))
    ? React.cloneElement(element, {
        key: `grid-element-${rowIndex}-${columnIndex}`,
        ...item,
        ooWidth: style.width - Config.GRID_COVER_PAD,
        style: mergeStyle(style)
      })
    : ( (loadMore && React.isValidElement(loadingElement))
      ? React.cloneElement(loadingElement, {
          key: `grid-element-${rowIndex}-${columnIndex}`,
          ooWidth: style.width - Config.GRID_COVER_PAD,
          style: mergeStyle(style)
        })
      : null
    )
}, areEqual);

function Grid({
  columnCount, columnWidth, rowCount, rowHeight, itemData, height, width, loadMore,
  gutter = { top: 4, left: 4, width: 4 }, style,
  element, loadingElement, id = null
}) {
  return (!itemData)
    ? <BlockLoading height={height} />
    : (
      <GridContext.Provider value={{ columns: columnCount, loadMore, gutter, element, loadingElement }}>
        <FixedSizeGrid
          className={`fixedSizeGrid-${id}`}
          columnCount={(itemData.length <= columnCount) ? itemData.length : columnCount}
          columnWidth={columnWidth}
          rowCount={rowCount}
          rowHeight={rowHeight}
          itemData={itemData}
          height={height}
          width={width}
          style={{...style}}
        >
          {Cell}
        </FixedSizeGrid>
      </GridContext.Provider>
    )
}

Grid.propTypes = {
  columnCount: PropTypes.number.isRequired,
  columnWidth: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  rowHeight: PropTypes.number.isRequired,
  itemData: PropTypes.any,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  loadMore: PropTypes.func,
  gutter: PropTypes.object,
  style: PropTypes.object,
  element: PropTypes.element.isRequired,
  loadingElement: PropTypes.element.isRequired
}

export default Grid;
